import React from 'react';

import YaShare, { IYaShareProps } from 'client/common/components/ya-share';

import './index.css';

export default (props: Omit<IYaShareProps, 'popup'>) => <YaShare {...props} popup={false} />;
